/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Check = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1 5H23V19H1V5ZM2.5 6.5V17.5H21.5V6.5H2.5ZM11 9.75H4V8.25H11V9.75ZM20 12.75H4V11.25H20V12.75ZM16.2483 15.7112C16.0888 15.3701 15.683 15.2229 15.3419 15.3824L12.5676 16.6794L11.9324 15.3206L14.7066 14.0235C15.7982 13.5132 17.0968 13.9844 17.6072 15.0759C17.6254 15.115 17.6425 15.1545 17.6583 15.1944C17.9211 15.1378 18.0897 15.0446 18.197 14.9465C18.3574 14.7999 18.5 14.5329 18.5 14H20C20 14.8004 19.778 15.5334 19.2092 16.0535C18.6531 16.562 17.8915 16.75 17.0625 16.75C16.6483 16.75 16.3125 16.4142 16.3125 16C16.3125 15.9002 16.2906 15.8016 16.2483 15.7112Z"
                        fill={color}
                    />
                </svg>
        );
    };
